import * as React from 'react'

import {
  ContentEpisodeRow,
  SUPPORT_TYPE_PINK,
  SUPPORT_TYPE_BLUE,
} from '~/molecules/content/ContentEpisodeRow'

import PcEpisode01 from './pc_episode01.png'
import PcEpisode02 from './pc_episode02.png'
import PcEpisode03 from './pc_episode03.png'
import PcEpisode04 from './pc_episode04.png'
import PcEpisode05 from './pc_episode05.png'
import PcEpisode06 from './pc_episode06.png'
import SpEpisode01 from './sp_episode01.png'
import SpEpisode02 from './sp_episode02.png'
import SpEpisode03 from './sp_episode03.png'
import SpEpisode04 from './sp_episode04.png'
import SpEpisode05 from './sp_episode05.png'
import SpEpisode06 from './sp_episode06.png'
import Pc01DevelopmentBefore from './01_development/pc_01_development_before.png'
import Pc02DevelopmentBefore from './02_development/pc_02_development_before.png'
import Pc03DevelopmentBefore from './03_development/pc_03_development_before.png'
import Pc04DevelopmentBefore from './04_development/pc_04_development_before.png'
import Pc05DevelopmentBefore from './05_development/pc_05_development_before.png'
import Pc06DevelopmentBefore from './06_development/pc_06_development_before.png'
import Sp01DevelopmentBefore from './01_development/sp_01_development_before.png'
import Sp02DevelopmentBefore from './02_development/sp_02_development_before.png'
import Sp03DevelopmentBefore from './03_development/sp_03_development_before.png'
import Sp04DevelopmentBefore from './04_development/sp_04_development_before.png'
import Sp05DevelopmentBefore from './05_development/sp_05_development_before.png'
import Sp06DevelopmentBefore from './06_development/sp_06_development_before.png'
import Pc01DevelopmentAfterTop from './01_development/pc_01_development_after_top.png'
import Pc02DevelopmentAfterTop from './02_development/pc_02_development_after_top.png'
import Pc03DevelopmentAfterTop from './03_development/pc_03_development_after_top.png'
import Pc04DevelopmentAfterTop from './04_development/pc_04_development_after_top.png'
import Pc05DevelopmentAfterTop from './05_development/pc_05_development_after_top.png'
import Pc06DevelopmentAfterTop from './06_development/pc_06_development_after_top.png'
import Sp01DevelopmentAfterTop from './01_development/sp_01_development_after_top.png'
import Sp02DevelopmentAfterTop from './02_development/sp_02_development_after_top.png'
import Sp03DevelopmentAfterTop from './03_development/sp_03_development_after_top.png'
import Sp04DevelopmentAfterTop from './04_development/sp_04_development_after_top.png'
import Sp05DevelopmentAfterTop from './05_development/sp_05_development_after_top.png'
import Sp06DevelopmentAfterTop from './06_development/sp_06_development_after_top.png'
import Pc01DevelopmentAfterBottom from './01_development/pc_01_development_after_bottom.png'
import Pc02DevelopmentAfterBottom from './02_development/pc_02_development_after_bottom.png'
import Pc03DevelopmentAfterBottom from './03_development/pc_03_development_after_bottom.png'
import Pc04DevelopmentAfterBottom from './04_development/pc_04_development_after_bottom.png'
import Pc05DevelopmentAfterBottom from './05_development/pc_05_development_after_bottom.png'
import Pc06DevelopmentAfterBottom from './06_development/pc_06_development_after_bottom.png'
import Sp01DevelopmentAfterBottom from './01_development/sp_01_development_after_bottom.png'
import Sp02DevelopmentAfterBottom from './02_development/sp_02_development_after_bottom.png'
import Sp03DevelopmentAfterBottom from './03_development/sp_03_development_after_bottom.png'
import Sp04DevelopmentAfterBottom from './04_development/sp_04_development_after_bottom.png'
import Sp05DevelopmentAfterBottom from './05_development/sp_05_development_after_bottom.png'
import Sp06DevelopmentAfterBottom from './06_development/sp_06_development_after_bottom.png'

import * as Style from './style.css'

export const ContentEpisodeRows = (): JSX.Element => {
  return (
    <div className={Style.ContentEpisodeRows}>
      <ContentEpisodeRow
        lastEpisode={false}
        supportType={SUPPORT_TYPE_PINK}
        supporterName={'いつか'}
        pcEpisode={PcEpisode01}
        pcDevelopmentBefore={Pc01DevelopmentBefore}
        pcDevelopmentAfterTop={Pc01DevelopmentAfterTop}
        pcDevelopmentAfterBottom={Pc01DevelopmentAfterBottom}
        spEpisode={SpEpisode01}
        spDevelopmentBefore={Sp01DevelopmentBefore}
        spDevelopmentAfterTop={Sp01DevelopmentAfterTop}
        spDevelopmentAfterBottom={Sp01DevelopmentAfterBottom}
        colorButtonAccordionTitle1={'ベビーシッターの仕事について'}
        colorButtonAccordionTitle2={'もっと知りたい'}
        colorButtonHref={'/sitters/welcome?source=award2024lp'}
        linkButtonAccordionTitle1={'いつかさんのエピソードを'}
        linkButtonAccordionTitle2={'もっと詳しく知りたい方はコチラ'}
        linkButtonHref={'/magazine/article/1013#3'}
      />
      <ContentEpisodeRow
        lastEpisode={false}
        supportType={SUPPORT_TYPE_BLUE}
        supporterName={'みか'}
        pcEpisode={PcEpisode02}
        pcDevelopmentBefore={Pc02DevelopmentBefore}
        pcDevelopmentAfterTop={Pc02DevelopmentAfterTop}
        pcDevelopmentAfterBottom={Pc02DevelopmentAfterBottom}
        spEpisode={SpEpisode02}
        spDevelopmentBefore={Sp02DevelopmentBefore}
        spDevelopmentAfterTop={Sp02DevelopmentAfterTop}
        spDevelopmentAfterBottom={Sp02DevelopmentAfterBottom}
        colorButtonAccordionTitle1={'家事代行サポーターの仕事について'}
        colorButtonAccordionTitle2={'もっと知りたい'}
        colorButtonHref={'/housekeeping/welcome?source=award2024lp'}
        linkButtonAccordionTitle1={'みかさんのエピソードを'}
        linkButtonAccordionTitle2={'もっと詳しく知りたい方はコチラ'}
        linkButtonHref={'/magazine/article/1013#6'}
      />
      <ContentEpisodeRow
        lastEpisode={false}
        supportType={SUPPORT_TYPE_PINK}
        supporterName={'まりえ'}
        pcEpisode={PcEpisode03}
        pcDevelopmentBefore={Pc03DevelopmentBefore}
        pcDevelopmentAfterTop={Pc03DevelopmentAfterTop}
        pcDevelopmentAfterBottom={Pc03DevelopmentAfterBottom}
        spEpisode={SpEpisode03}
        spDevelopmentBefore={Sp03DevelopmentBefore}
        spDevelopmentAfterTop={Sp03DevelopmentAfterTop}
        spDevelopmentAfterBottom={Sp03DevelopmentAfterBottom}
        colorButtonAccordionTitle1={'ベビーシッターの仕事について'}
        colorButtonAccordionTitle2={'もっと知りたい'}
        colorButtonHref={'/sitters/welcome?source=award2024lp'}
        linkButtonAccordionTitle1={'まりえさんのエピソードを'}
        linkButtonAccordionTitle2={'もっと詳しく知りたい方はコチラ'}
        linkButtonHref={'/magazine/article/1013#4'}
      />
      <ContentEpisodeRow
        lastEpisode={false}
        supportType={SUPPORT_TYPE_BLUE}
        supporterName={'いくみ'}
        pcEpisode={PcEpisode04}
        pcDevelopmentBefore={Pc04DevelopmentBefore}
        pcDevelopmentAfterTop={Pc04DevelopmentAfterTop}
        pcDevelopmentAfterBottom={Pc04DevelopmentAfterBottom}
        spEpisode={SpEpisode04}
        spDevelopmentBefore={Sp04DevelopmentBefore}
        spDevelopmentAfterTop={Sp04DevelopmentAfterTop}
        spDevelopmentAfterBottom={Sp04DevelopmentAfterBottom}
        colorButtonAccordionTitle1={'家事代行サポーターの仕事について'}
        colorButtonAccordionTitle2={'もっと知りたい'}
        colorButtonHref={'/housekeeping/welcome?source=award2024lp'}
        linkButtonAccordionTitle1={'いくみさんのエピソードを'}
        linkButtonAccordionTitle2={'もっと詳しく知りたい方はコチラ'}
        linkButtonHref={'/magazine/article/1013#7'}
      />
      <ContentEpisodeRow
        lastEpisode={false}
        supportType={SUPPORT_TYPE_PINK}
        supporterName={'ゆうこ'}
        pcEpisode={PcEpisode05}
        pcDevelopmentBefore={Pc05DevelopmentBefore}
        pcDevelopmentAfterTop={Pc05DevelopmentAfterTop}
        pcDevelopmentAfterBottom={Pc05DevelopmentAfterBottom}
        spEpisode={SpEpisode05}
        spDevelopmentBefore={Sp05DevelopmentBefore}
        spDevelopmentAfterTop={Sp05DevelopmentAfterTop}
        spDevelopmentAfterBottom={Sp05DevelopmentAfterBottom}
        colorButtonAccordionTitle1={'ベビーシッターの仕事について'}
        colorButtonAccordionTitle2={'もっと知りたい'}
        colorButtonHref={'/sitters/welcome?source=award2024lp'}
        linkButtonAccordionTitle1={'ゆうこさんのエピソードを'}
        linkButtonAccordionTitle2={'もっと詳しく知りたい方はコチラ'}
        linkButtonHref={'/magazine/article/1013#5'}
      />
      <ContentEpisodeRow
        lastEpisode={true}
        supportType={SUPPORT_TYPE_BLUE}
        supporterName={'あゆみ'}
        pcEpisode={PcEpisode06}
        pcDevelopmentBefore={Pc06DevelopmentBefore}
        pcDevelopmentAfterTop={Pc06DevelopmentAfterTop}
        pcDevelopmentAfterBottom={Pc06DevelopmentAfterBottom}
        spEpisode={SpEpisode06}
        spDevelopmentBefore={Sp06DevelopmentBefore}
        spDevelopmentAfterTop={Sp06DevelopmentAfterTop}
        spDevelopmentAfterBottom={Sp06DevelopmentAfterBottom}
        colorButtonAccordionTitle1={'家事代行サポーターの仕事について'}
        colorButtonAccordionTitle2={'もっと知りたい'}
        colorButtonHref={'/housekeeping/welcome?source=award2024lp'}
        linkButtonAccordionTitle1={'あゆみさんのエピソードを'}
        linkButtonAccordionTitle2={'もっと詳しく知りたい方はコチラ'}
        linkButtonHref={'/magazine/article/1013#8'}
      />
    </div>
  )
}
